import { useEffect, useState } from "react";
import {
  CheckIcon,
  Combobox,
  Group,
  Input,
  Pill,
  PillsInput,
  Loader,
  useCombobox,
} from "@mantine/core";
import { HiOutlineChevronUpDown } from "react-icons/hi2";
const CustomMultiSelect = ({
  setReportParams,
  data,
  isLoading,
  reportParams,
}) => {
  const [value, setValue] = useState([]);
  useEffect(() => {
    if (value) {
      setReportParams((prev) => ({
        ...prev,
        floorID: value,
      }));
    }
  }, [value]);

  useEffect(() => {
    setValue([]);
  }, [reportParams.locationID]);

  useEffect(() => {
    setValue(reportParams.floorID);
  }, []);
  const combobox = useCombobox({
    onDropdownClose: () => combobox.resetSelectedOption(),
    onDropdownOpen: () => combobox.updateSelectedOptionIndex("active"),
  });

  const handleValueSelect = (val: string) =>
    setValue((current) =>
      current.includes(val)
        ? current.filter((v) => v !== val)
        : [...current, val]
    );

  const handleValueRemove = (val: string) =>
    setValue((current) => current.filter((v) => v !== val));

  const values = value.map((item) => (
    <Pill key={item} withRemoveButton onRemove={() => handleValueRemove(item)}>
      {data.find((floor) => floor.value === item)?.label}
    </Pill>
  ));

  const options = data.map((item) => (
    <Combobox.Option
      value={item.value}
      key={item.value}
      active={value.includes(item.value)}
    >
      <Group gap="sm">
        {value.includes(item.value) ? <CheckIcon size={12} /> : null}
        <span>{item.label}</span>
      </Group>
    </Combobox.Option>
  ));

  return (
    <Combobox
      store={combobox}
      onOptionSubmit={handleValueSelect}
      withinPortal={false}
    >
      <Combobox.DropdownTarget>
        <PillsInput
          pointer
          onClick={() => combobox.toggleDropdown()}
          rightSection={
            isLoading ? <Loader size={18} /> : <HiOutlineChevronUpDown />
          }
        >
          <Pill.Group>
            {values}

            <Combobox.EventsTarget>
              <PillsInput.Field
                type="hidden"
                onBlur={() => combobox.closeDropdown()}
                onKeyDown={(event) => {
                  if (event.key === "Backspace") {
                    event.preventDefault();
                    handleValueRemove(value[value.length - 1]);
                  }
                }}
              />
            </Combobox.EventsTarget>
          </Pill.Group>
        </PillsInput>
      </Combobox.DropdownTarget>

      <Combobox.Dropdown>
        {isLoading ? (
          <Combobox.Empty>Loading....</Combobox.Empty>
        ) : data.length === 0 ? (
          <Combobox.Empty>No Floors</Combobox.Empty>
        ) : (
          options
        )}
      </Combobox.Dropdown>
    </Combobox>
  );
};

export default CustomMultiSelect;
